import { createSlice } from "@reduxjs/toolkit";
import { ProductSliceProp } from "../../Type/Redux";

const initialState:ProductSliceProp = {
  productItem: [],
  symbol: "$",
};

const ProductSlice = createSlice({
  name: "ProductSlice",
  initialState,
  reducers: {
    setProductItem: (state, action) => {
      state.productItem = action.payload;
    },
  },
});
export const { setProductItem } = ProductSlice.actions;

export default ProductSlice.reducer;
